import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import { LinkButton } from '@backstage/core-components';
import { Link, Flex,  List,  ListRow,  Text,  Header } from '@backstage/ui';
import useAsync from 'react-use/lib/useAsync';
import { Progress } from '@backstage/core-components';
import { EntityDisplayName} from '@backstage/plugin-catalog-react';
import { stringifyEntityRef, parseEntityRef } from '@backstage/catalog-model';

import { useApi } from '@backstage/core-plugin-api';
import { announcementsApiRef } from '@backstage-community/plugin-announcements-react';
import {
  AnnouncementsList,
} from '@backstage-community/plugin-announcements-common'

type AnnouncementsCardContentProps = {
  announcements?: AnnouncementsList;  
}

const AnnouncementsCardContent = (value: AnnouncementsCardContentProps) => {
  return (
    <div>
      <Header title="Latest Announcements"/>

      <List layout="grid" renderEmptyState={() => 'No results found.'} className="relative flex-1 overflow-auto" aria-label="Announcements">
        {value.announcements?.results.map((a, idx) => (
          <ListRow
            key={a.id}
            style={idx === 0 ? { borderLeft: '3px solid #35abe2', paddingLeft: '8px' } : undefined}
            
          >
            <Flex direction="column" gap="1">
              <Link truncate variant="body-medium" color="info" href={`/announcements/view/${a.id}`}>
                {a.title}
              </Link>
              <Text variant="body-small">
                {'By '}
                {a.on_behalf_of && (
                  <Link href={`/catalog/${stringifyEntityRef(parseEntityRef(a.on_behalf_of))}`}>
                    <EntityDisplayName entityRef={a.on_behalf_of} />
                  </Link>
                )}
                {' · '}
                {new Date(a.start_at).toLocaleDateString()}
              </Text>
            </Flex>
            <p className="line-clamp-2 m-5">{a.excerpt}</p>
          </ListRow>
        ))}
      </List>
    </div>
  );
};

export default function AnnouncementsCard() {
  const announcementsApi = useApi(announcementsApiRef);
    
  const { value, loading, error } = useAsync(async (): Promise< | AnnouncementsList> => {    
    return await announcementsApi.announcements({ max:5, page:1, active:true, sortBy:'created_at', order:'desc' });    
  }, []);

  if (loading) {
    return <Progress />;
  } else if (error) {
    return <AnnouncementsCardContent  />;
  }
  
  return (    
        <AnnouncementsCardContent 
          announcements={value}
        />    
  );
}

export const Actions = () => {
  return (
    <LinkButton to='/announcements'
    >
      More Announcements
    </LinkButton>
  );
};
export const Content = AnnouncementsCard        

export const announcementWidget = HomePageWidgetBlueprint.make({
  name: 'announcement-widget',
  params: {
    name: 'AnnouncementWidget',        
    description: 'An announcement widget for the homepage, showing the latest news and updates from the announcements plugin.',
    components: () =>
      import('./AnnouncementsCard').then(m => ({
        Content: m.Content, 
        Actions: m.Actions 
      })),      
    layout: {
      height: { minRows: 5, defaultRows: 5 },
      width: { minColumns: 3, defaultColumns: 3 },
    },
  },
}) as any;